import { HTTP } from './helpers/http.js'
import qs from 'qs'

export default {
  find(organizationId, params) {
    const { limit = 25, skip = 0, sort } = params

    const parsedParams = {
      params: { skip, limit, sort, filters: { source: 'web' }, source: 'web' }, //TODO: Remove this source param when the flag will deleted
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
    }

    return HTTP.get(
      `/api/v1/organizations/${organizationId}/apikeys`,
      parsedParams
    )
  },

  create(organizationId, data) {
    const url = `/api/v1/organizations/${organizationId}/apikeys`
    return HTTP.post(url, data)
  },

  update(organizationId, apiKeyId, data) {
    const url = `/api/v1/organizations/${organizationId}/apikeys/${apiKeyId}`
    return HTTP.patch(url, data)
  },

  delete(organizationId, apiKeyId) {
    const url = `/api/v1/organizations/${organizationId}/apikeys/${apiKeyId}`
    return HTTP.delete(url)
  },
}
